// extracted by mini-css-extract-plugin
export var body = "_jx-0";
export var sectionHeader = "_jx-4";
export var shortcutColumns = "_jx-2";
export var shortcutList = "_jx-1";
export var shortcutSection = "_jx-3";